<div class="om-datepicker {{ hostClass() }}">
  <p-datepicker
    [formControl]="control()"
    [inputId]="inputId()"
    [dateFormat]="dateFormat()"
    [placeholder]="placeholder()"
    [showIcon]="true"
    [iconDisplay]="'input'"
    [showOnFocus]="true"
    appendTo="body"
    styleClass="om-datepicker-input"
    (onSelect)="onSelect($event)"
  />
</div>
